// This file points to the latest products JSON file
// Last updated: 2025-10-14T05:37:02.140Z
// Auto-generated by update-latest-products.js

// Current version: products-2025-10-14-051534.json
import productsData from './products-2025-10-14-051534.json';

export default productsData;
